import router from '@/system/engine/router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import {removeTokenByName, getTokenByName} from '@/system/store/cookie';

NProgress.configure({ showSpinner: false });

const whiteList = ['/','/maintenance', '/nofound'];

router.beforeEach((to, from, next) =>{
	NProgress.start();
	
	var routerPath = to.path;
	var explodeToPath = routerPath.substring(1);
	explodeToPath = explodeToPath.split('/');
	
	if(whiteList.indexOf(to.path) !== -1 || explodeToPath[0] == 'affiliate'){
		next();
	}else{
		if(getTokenByName('auth_sign_token')){
			next();
		}else{
			next('/');
		}
	}
	
});

router.afterEach(() => {
	NProgress.done();
});




